import type React from 'react'
import type { ReactElement } from 'react'

export function IconWithdraw(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg width={54} height={52} viewBox={'0 0 54 52'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'} {...props}>
      <path
        d={
          'M28.0507 0.439339C27.4649 -0.146446 26.5151 -0.146446 25.9293 0.439339L16.3834 9.98528C15.7976 10.5711 15.7976 11.5208 16.3834 12.1066C16.9692 12.6924 17.9189 12.6924 18.5047 12.1066L26.99 3.62132L35.4753 12.1066C36.0611 12.6924 37.0108 12.6924 37.5966 12.1066C38.1824 11.5208 38.1824 10.5711 37.5966 9.98528L28.0507 0.439339ZM26.99 38.5L28.49 38.5L28.49 1.5L26.99 1.5L25.49 1.5L25.49 38.5L26.99 38.5Z'
        }
        fill={'currentColor'}
      />
      <path
        d={
          'M48 18.5C51.3137 18.5 54 21.1863 54 24.5V45.5L53.9922 45.8086C53.8367 48.8767 51.3767 51.3367 48.3086 51.4922L48 51.5H6L5.69141 51.4922C2.62332 51.3367 0.163251 48.8767 0.0078125 45.8086L0 45.5V24.5C9.66416e-08 21.1863 2.68629 18.5 6 18.5H19V21.5H6C4.34315 21.5 3 22.8431 3 24.5V45.5C3 47.1569 4.34315 48.5 6 48.5H48C49.6569 48.5 51 47.1569 51 45.5V24.5C51 22.8431 49.6569 21.5 48 21.5H34V18.5H48Z'
        }
        fill={'currentColor'}
      />
    </svg>
  )
}
